import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput } from "./../style";
import InputForm from "../../../../../shared/atoms/InputForm";

import { patternOnlyNumbers } from "../../../../../shared/create-offer/utils/masks";

import { useNewOfferMobile } from "../../context";
import InfoBankStep from "./infosSeeMore/InfoBankStep"

const AgencyInput = ({ step, bankData, onChangeBankData }) => {
	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		bankId: bankData.data.bankId,
		agency: bankData.data.agency || "",
		hasError: false
	});

	useEffect(() => {
		setStepError(
			!state.agency.length ||
				state.agency.length < 3 ||
				(state.bankId != 45 && state.agency.length > 4)
		);
	}, [state]);

	const onChange = ev => {
		let agency = ev.target.value.match(patternOnlyNumbers)
			? ev.target.value
					.match(patternOnlyNumbers)
					.join("")
					.toString()
			: "";
		setState({
			...state,
			agency: state.bankId == 45 ? agency.replace(/(\d)(\d{1}$)/g, "$1-$2") : agency,
			hasError: !agency.length || agency.length < 3 || (state.bankId != 45 && agency.length > 4)
		});

		onChangeBankData({
			agency: state.bankId == 45 ? agency.replace(/(\d)(\d{1}$)/g, "$1-$2") : agency
		});
	};

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados bancários
			</strong>
			<div
				className={css`
					${singleInput};
				`}
			>
				<InputForm
					name="agency"
					id="agency"
					type="tel"
					value={state.bankId == 45 ? state.agency.replace(/(\d)(\d{1}$)/g, "$1-$2") : state.agency}
					onChange={onChange}
					placeholder=""
					label="Agência"
					maxLength={state.bankId == 45 ? 6 : 4}
					hasError={state.hasError}
					errorMessage="Preencha corretamente o campo agência."
					data-action="register-bank-details-agency"
				/>
			</div>

			<InfoBankStep/>
		</div>
	);
};

export default AgencyInput;
